const coreConfig = {
  KEY_PREFIX: 'nj',
  DATA_API_KEY: '.data-api'
};

const eventsName = {
  click      : 'click',
  close      : 'close',
  closed     : 'closed',
  hide       : 'hide',
  hidden     : 'hidden',
  input      : 'input',
  keydown    : 'keydown',
  keyup      : 'keyup',
  show       : 'show',
  shown      : 'shown',
  inserted   : 'inserted',
  focusin    : 'focusin',
  focusout   : 'focusout',
  mouseenter : 'mouseenter',
  mouseleave : 'mouseleave',
  mouseup    : 'mouseup',
  mousedown  : 'mousedown'
};

export {
  coreConfig,
  eventsName
};
